import styled from 'styled-components';

import { AccordionAnimate } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const SRounderContainer = styled(RounderContainer)`
    background-color: ${COLORS.BgMain};
    padding: 10px 16px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
      padding: 4px 16px;
    }
`;

export const SAccordionAnimate = styled(AccordionAnimate)`
   width: 100%;
   flex-direction: column;
`;

export const Icon = styled.img`
    width: 40px;
    height: 40px;
`;

export const Head = styled.div`
    width: 100%;
    align-items: center;
    gap: 12px;
`;

export const Title = styled.div`
    align-items: center;
    gap: 8px;
`;

export const SubscriptonsWrap = styled.div`
    width: 100%  ;
    padding: 8px 8px 0 8px;
  
    @media (max-width: ${wideBreakpoints.mobile}) {
          padding: 8px 0 0 0;
    }
`;

export const SubscriptionItem = styled.div`
    width: 100%;
    padding: 12px 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${COLORS.Outline_Light};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
          &:last-child {
            padding-bottom: 0;
          }
    }
`;

export const ArrowButton = styled(Button)<{isShow: boolean}>`
    margin-left: auto;
    transform: scaleY(${({ isShow }) => isShow ? '-1' : '1'});
`;
